
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("5VHmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $4513eaa58ab24206$var$_jquery = $4513eaa58ab24206$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $4513eaa58ab24206$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $4513eaa58ab24206$var$screencheck = function screencheck(mediasize) {
    var screensize = window.matchMedia("(max-width:" + mediasize + "px)");
    return !!screensize.matches;
};
var $4513eaa58ab24206$var$init = module.exports.init = function init() {
    var attempts = 0;
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            (0, $4513eaa58ab24206$var$_jquery["default"])(document).on("click touchend", "#menu", function() {
                var pageHeader = (0, $4513eaa58ab24206$var$_jquery["default"])("body:not(.flyout-header) .page-header");
                pageHeader.addClass("fixed");
                pageHeader.removeClass("navhide");
                (0, $4513eaa58ab24206$var$_jquery["default"])(this).next(".nav-container").addClass("nav-container-open");
                (0, $4513eaa58ab24206$var$_jquery["default"])(this).next(".nav-container").slideDown("normal");
                return !1;
            });
            (0, $4513eaa58ab24206$var$_jquery["default"])(".nav-container").on("click touchend", function(event) {
                if ((0, $4513eaa58ab24206$var$_jquery["default"])(window).width() < 768) event.stopPropagation();
            });
            (0, $4513eaa58ab24206$var$_jquery["default"])(".nav > li > a").on("click", function() {
                if ($4513eaa58ab24206$var$screencheck(1024) && (0, $4513eaa58ab24206$var$_jquery["default"])("body.youth").length < 1) return (0, $4513eaa58ab24206$var$_jquery["default"])(this).parent("li").find(".megamenu").is(":visible") ? ((0, $4513eaa58ab24206$var$_jquery["default"])(this).parent("li").find(".megamenu").slideUp("normal"), (0, $4513eaa58ab24206$var$_jquery["default"])(this).parent("li").removeClass("current"), (0, $4513eaa58ab24206$var$_jquery["default"])(".nav").removeClass("hovered"), !1) : ((0, $4513eaa58ab24206$var$_jquery["default"])(".megamenu").slideUp("normal"), (0, $4513eaa58ab24206$var$_jquery["default"])(".nav").removeClass("hovered"), (0, $4513eaa58ab24206$var$_jquery["default"])(".nav > li").removeClass("current"), (0, $4513eaa58ab24206$var$_jquery["default"])(".nav").addClass("hovered"), (0, $4513eaa58ab24206$var$_jquery["default"])(this).parent("li").addClass("current"), (0, $4513eaa58ab24206$var$_jquery["default"])(this).parent("li").find(".megamenu").slideDown("normal"), !1);
            });
            (0, $4513eaa58ab24206$var$_jquery["default"])(".close-menu").on("click touchend", function() {
                (0, $4513eaa58ab24206$var$_jquery["default"])(this).parents(".nav-container").slideUp("normal");
                (0, $4513eaa58ab24206$var$_jquery["default"])(this).parents(".nav-container").removeClass("nav-container-open");
                (0, $4513eaa58ab24206$var$_jquery["default"])("input").blur();
                return !1;
            });
            (0, $4513eaa58ab24206$var$_jquery["default"])(".menulines-button").on("click touchend", function() {
                if ((0, $4513eaa58ab24206$var$_jquery["default"])(".nav-container-open").length) {
                    // console.log("--- open ---");
                    (0, $4513eaa58ab24206$var$_jquery["default"])(this).parent().find(".nav-container").slideUp("normal");
                    (0, $4513eaa58ab24206$var$_jquery["default"])(this).parent().find(".nav-container").removeClass("nav-container-open");
                    (0, $4513eaa58ab24206$var$_jquery["default"])("input").blur();
                    return !1;
                }
            });
            (0, $4513eaa58ab24206$var$_jquery["default"])(".megamenu").on("click touchend", function(event) {
                event.stopPropagation();
            });
            (0, $4513eaa58ab24206$var$_jquery["default"])(document).on("click", function(e) {
                0 === (0, $4513eaa58ab24206$var$_jquery["default"])(e.target).parent(".nav > li > a").length && ((0, $4513eaa58ab24206$var$_jquery["default"])(".megamenu").fadeOut("fast"), (0, $4513eaa58ab24206$var$_jquery["default"])(".nav").removeClass("hovered"), (0, $4513eaa58ab24206$var$_jquery["default"])(".nav > li").removeClass("current")), (0, $4513eaa58ab24206$var$_jquery["default"])("body:not(.flyout-header) .page-header").removeClass("fixed");
            });
        } else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=mobileMenu.module.cd564a38.js.map
